import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import { Col, notification, Row, Button, Tag, Typography } from 'antd';
import { ErrorRender } from '@partsbadger/library';
import QuoteStore from '../../stores/QuoteStore';
import UserStore from '../../stores/UserStore';
import '../../utils/pdfWorker';
import { QuoteOneTrueForm } from '@partsbadger/one-true-form';
import SalesOrderStore from '../../stores/SalesOrderStore';
import PortalLoading from 'components/PortalLoading';
import { PageHeader } from 'components/PageHeader';

import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const GetQuote = observer(() => {
    const history = useHistory();
    const [loadingQuote, setLoadingQuote] = useState(false);
    const [is_new_contact, setIsNewContact] = useState(false);
    const [quote, setQuote] = useState<any>();

    const params = useQuery();

    const uid = params.get('uid');

    useEffect(() => {
        if (uid) {
            setLoadingQuote(true);
            try {
                QuoteStore.getQuoteByUid(uid)
                    .then(quote => {
                        setQuote(quote);
                        setIsNewContact(false);
                    })
                    .catch(() => {
                        history.replace('/my-account/quotes/');
                    })
                    .finally(() => setLoadingQuote(false));
            } catch (err: any) {
                notification.error({
                    duration: 10,
                    message: 'Error',
                    description: <ErrorRender error={err} />,
                    placement: 'bottomRight',
                });
                setLoadingQuote(false);
            }
        }
    }, []);

    const goCheckoutPage = async (quote_uid: string, contact_id: number) => {
        await SalesOrderStore.createOrderDraft({ contact: contact_id, quotes: [quote_uid] }).then(order => {
            history.replace(`/my-account/orders/new/${order.id}/`);
        });
    };

    if (loadingQuote) {
        return <PortalLoading />;
    }

    const back = () => {
        history.goBack();
    };

    return (
        <>
            <PageHeader>
                <div className="d-flex flex-column align-items-baseline">
                    <Button type="link" icon={<ArrowLeftOutlined />} onClick={back} className="text-primary m-0 p-0">
                        Back to Quote List
                    </Button>
                    <Title level={1} className="mb-2">
                        {quote?.name}
                    </Title>
                    <Tag color="blue">Requote</Tag>
                </div>
            </PageHeader>

            <div className="container">
                {!!quote && UserStore.token && (
                    <QuoteOneTrueForm
                        acquisition_source={'Portal'}
                        quote={quote}
                        token={UserStore.token}
                        onRequestOrder={goCheckoutPage}
                        is_new_contact={is_new_contact}
                        for_staff={false}
                        onQuoteSubmitted={() => {
                            const args = {
                                message: 'Your Re-Quote was sent!',
                                description:
                                    "Thank you for using PartsBadger's Quote submission form. Your quote will be updated shortly!",
                                duration: 20,
                            };
                            notification.success(args);

                            history.replace('/my-account/quotes');
                        }}
                    />
                )}
            </div>
        </>
    );
});
